<template>
  <div class="basic_classification_edit" :class="listArr.child_trigger == 'all_open' && (listArr.moduleStyle === 0 || listArr.moduleStyle === 1) ? 'all_open' : 'not_all_open'" @mouseenter="module_isHover(true)" @mouseleave="module_isHover(false)" @dblclick="changeStyle('style')">
    <div class="tooptipPart module_edit_btn" v-if="isHover">
      <my_hover_btn :tips="$t('widgets_basic_article_classification_index_336')" btnIcon="el-icon-edit" @changeStyle="changeStyle('style')"></my_hover_btn>
      <my_hover_btn :tips="$t('widgets_basic_article_classification_edit_330')" btnIcon="el-icon-magic-stick" @changeStyle="changeStyle('animation')" v-if="$store.state.app.view_pattern === 'pc'"></my_hover_btn>
      <my_hover_btn :tips="$t('widgets_basic_article_classification_index_337')" btnIcon="el-icon-edit-outline" @changeStyle="add_content" v-if="$store.state.app.view_pattern === 'pc' && listArr.classificationSelect !== 'navbar'"></my_hover_btn>
      <my_close_btn :module="module" :column="column" :moduleIndex="module_index" v-if="$store.state.app.view_pattern === 'pc'"></my_close_btn>
    </div>
    <my_title_index :title="infor.title"></my_title_index>
    <div v-if="$store.state.app.view_pattern === 'pc'" class="view_pattern_pc">
      <div class="data_empty" v-if="filterList.length == 0">
        <i class="empty_tips_img"></i>
        <div class="empty_tips_text">{{$t('widgets_basic_classification_index_483')}}</div>
        <div class="btn_group">
          <el-button type="primary" size="medium" @click="changeStyle('style')">{{$t('widgets_basic_article_classification_index_339')}}</el-button>
          <el-button size="medium" @click="add_content">{{$t('widgets_basic_article_classification_edit_320')}}</el-button>
        </div>
      </div>
      <div :class="`type_${listArr.moduleStyle}`" v-if="listArr.child_trigger == 'all_open' && (listArr.moduleStyle === 0 || listArr.moduleStyle === 1)">
        <ul class="level_1">
          <li v-for="(parent,parentIndex) in filterList" :key="parentIndex" class="level_1_content" :class="infor.icon.radio_val == 'custom' ? `level_1_content_${infor.icon.custom.icon_position}` : 'level_1_content_'">
            <div class="level_1_content_new parent_content" @mouseenter="(e)=>{hover_Level2(e,-1,false);hoverMoveChange(e, true,'level_1');}" @mouseleave="(e)=>{hoverMoveChange(e, false,'level_1');}" :class="infor.icon.radio_val == 'custom' ? `item_content_${infor.icon.custom.icon_position}` : 'item_content'" :style="[{
              borderBottom: `${infor.splitLine_level_1[infor.splitLine_level_1.radio_val].borderWidth}px ${infor.splitLine_level_1[infor.splitLine_level_1.radio_val].borderStyle} ${infor.splitLine_level_1[infor.splitLine_level_1.radio_val].borderColor}`,
              background: background_level_1,
              '--sebackground_1': se_background_level_1
            }]">
              <span class="label_1_name" 
              @click.stop="templet.is_jump({href:`${routerType}?${linkKey}=${parent.id}&name=${parent.name}`,target:pc_widgets_infor.linkType})"
              :style="[lineHeight_level_1,
                  Number(searchID) === Number(parent.id) ? se_fontStyle_level_1 : fontStyle_level_1,{
                    '--fontSeColor_1': infor.font_level_1[infor.font_level_1.radio_val].selectColor
                  }]">
                {{ parent.name }}
              </span>
              <div class="img_content" @click.stop="openLevel1($event,parent)" :style="imgContentStyle">
                <img :style="{
                  width: infor.icon[infor.icon.radio_val].icon_width + 'px',
                  height: infor.icon[infor.icon.radio_val].icon_width + 'px',
                  opacity: (parent.children && parent.children.length > 0  || listArr.classificationSelect == 'appoint') && infor.icon.radio_val == 'custom' ? 1 : 0
                }" class="level_icon level_1_icon open" :src="infor.icon[infor.icon.radio_val].icon_url">
              </div>
            </div>
            <ul class="level_2">
              <li class="level_2_content" v-for="(child,childIndex) in parent.children" :key="childIndex">
                <div class="level_2_content_new child_content" @mouseenter="(e)=>{hover_Level2(e,child.id,true);hoverMoveChange(e, true,'level_2');}" @mouseleave="(e)=>{hoverMoveChange(e, false,'level_2');}" :class="infor.icon.radio_val == 'custom' ? `item_content_${infor.icon.custom.icon_position}` : 'item_content'" :style="[{
                    borderBottom: `${infor.splitLine_level_2[infor.splitLine_level_2.radio_val].borderWidth}px ${infor.splitLine_level_2[infor.splitLine_level_2.radio_val].borderStyle} ${infor.splitLine_level_2[infor.splitLine_level_2.radio_val].borderColor}`,
                    background: background_level_2,
                    '--sebackground_2': se_background_level_2
                  }]">
                  <span class="label_2_name"
                  @click.stop="templet.is_jump({href:`${routerType}?${linkKey}=${child.id}&name=${child.name}`,target:pc_widgets_infor.linkType})"
                  :style="[lineHeight_level_2,
                      Number(searchID) === Number(child.id) ? se_fontStyle_level_2 : fontStyle_level_2,{
                        '--fontSeColor_2': infor.font_level_2[infor.font_level_2.radio_val].selectColor
                      }]">{{ child.name }}
                  </span>
                  <div class="img_content" @click.stop="openLevel2($event,child)" :style="imgContentStyle">
                    <img class="level_icon level_2_icon"
                    :class="{open : listArr.child_trigger == 'all_open' && listArr.moduleStyle === 0}"
                    :style="{
                      width: infor.icon[infor.icon.radio_val].icon_width + 'px',
                      height: infor.icon[infor.icon.radio_val].icon_width + 'px',
                      opacity: child.children && child.children.length > 0 && infor.icon.radio_val == 'custom' ? 1 : 0
                    }" :src="infor.icon[infor.icon.radio_val].icon_url">
                  </div>
                </div>
                <ul v-show="level_2_index == child.id && child.children && child.children.length > 0" @mouseleave="(e)=>{hover_Level2(e,-1,false)}" class="level_3">
                  <li class="level_3_content" v-for="(son,index) in child.children" :key="index">
                    <div @mouseenter="(e)=>{hoverMoveChange(e, true,'level_3')}" @mouseleave="(e)=>{hoverMoveChange(e, false,'level_3')}" class="level_3_content_new son_content" :style="[{
                          background: background_level_3,
                          borderBottom: `${infor.splitLine_level_3[infor.splitLine_level_3.radio_val].borderWidth}px ${infor.splitLine_level_3[infor.splitLine_level_3.radio_val].borderStyle} ${infor.splitLine_level_3[infor.splitLine_level_3.radio_val].borderColor}`,
                          '--sebackground_3': se_background_level_3
                        }]">
                      <span class="label_3_name"
                      @click.stop="templet.is_jump({href:`${routerType}?${linkKey}=${son.id}&name=${son.name}`,target:pc_widgets_infor.linkType})"
                      :style="[label3PL,Number(searchID) === Number(son.id) ? se_fontStyle_level_3 : fontStyle_level_3, lineHeight_level_3,{
                              '--fontSeColor_3': infor.font_level_3[infor.font_level_3.radio_val].selectColor
                            }]">{{ son.name }}
                      </span>
                    </div>
                  </li>
                </ul>
              </li>
            </ul>
          </li>
        </ul>
      </div>
      <div :class="`type_${listArr.moduleStyle}`" v-if="(listArr.child_trigger !== 'all_open' && (listArr.moduleStyle === 0 || listArr.moduleStyle === 1)) || (listArr.moduleStyle === 3 && !(listArr.classificationSelect === 'appoint' && listArr.appoint_child_trigger !== 'no_expand'))">
        <ul class="level_1">
          <li v-for="(parent,parentIndex) in filterList" :key="parentIndex" class="level_1_content" :class="infor.icon.radio_val == 'custom' ? `level_1_content_${infor.icon.custom.icon_position}` : 'level_1_content_'">
            <div class="level_1_content_new parent_content" @mouseenter="(e)=>{hoverMoveChange(e, true,'level_1')}" @mouseleave="(e)=>{hoverMoveChange(e, false,'level_1')}" :class="infor.icon.radio_val == 'custom' ? `item_content_${infor.icon.custom.icon_position}` : 'item_content'" :style="[{
              borderBottom: `${infor.splitLine_level_1[infor.splitLine_level_1.radio_val].borderWidth}px ${infor.splitLine_level_1[infor.splitLine_level_1.radio_val].borderStyle} ${infor.splitLine_level_1[infor.splitLine_level_1.radio_val].borderColor}`,
              background: seParentIndex == parentIndex || isSelected(parent) ? se_background_level_1 : background_level_1,
              '--sebackground_1': se_background_level_1
            }]" >
              <span class="label_1_name" v-if="listArr.classificationSelect === 'navbar'" @click="navbarLink(parent)" :style="[fontStyle_level_1, lineHeight_level_1,{
                    '--fontSeColor_1': infor.font_level_1[infor.font_level_1.radio_val].selectColor
                  },seParentIndex == parentIndex || isSelected(parent) ? se_fontStyle_level_1 : '']">
                {{ parent.name }}
              </span>
              <span v-else class="label_1_name"
              @click.stop="templet.is_jump({href:`${routerType}?${linkKey}=${parent.id}&name=${parent.name}`,target:pc_widgets_infor.linkType})" 
              :style="[fontStyle_level_1, lineHeight_level_1,{
              '--fontSeColor_1': infor.font_level_1[infor.font_level_1.radio_val].selectColor
            },seParentIndex == parentIndex || isSelected(parent) ? se_fontStyle_level_1 : '']">
                {{ parent.name }}
              </span>
              <div class="img_content" @click.stop="parent.children && parent.children.length > 0 ? openOrShowChild($event,parentIndex) : ''" :style="imgContentStyle">
                <img :class="(seParentIndex == parentIndex || isOpened(parent)) && listArr.classificationSelect !== 'appoint' ? 'open' : ''" :style="{
                  width: infor.icon[infor.icon.radio_val].icon_width + 'px',
                  height: infor.icon[infor.icon.radio_val].icon_width + 'px',
                  opacity: (parent.children && parent.children.length > 0  || listArr.classificationSelect !== 'all') && infor.icon.radio_val == 'custom' ? 1 : 0
                }" class="level_icon level_1_icon" :src="infor.icon[infor.icon.radio_val].icon_url">
              </div>
            </div>
            <ul class="level_2" :class="{selected : isSelected(parent), opened: isOpened(parent)}">
              <li class="level_2_content" v-for="(child,childIndex) in parent.children" :key="childIndex">
                <div class="level_2_content_new child_content" @mouseenter="(e)=>{mouse_dialog_show(e,childIndex,true,'level_2');hoverMoveChange(e, true,'level_2')}" @mouseleave="(e)=>{mouse_dialog_show(e,childIndex,false,'level_2');hoverMoveChange(e, false,'level_2')}" :class="infor.icon.radio_val == 'custom' ? `item_content_${infor.icon.custom.icon_position}` : 'item_content'"  :style="[{
                    borderBottom: `${infor.splitLine_level_2[infor.splitLine_level_2.radio_val].borderWidth}px ${infor.splitLine_level_2[infor.splitLine_level_2.radio_val].borderStyle} ${infor.splitLine_level_2[infor.splitLine_level_2.radio_val].borderColor}`,
                    background: seChildIndex == childIndex || isSelected(child) ? se_background_level_2 : background_level_2,
                    '--sebackground_2': se_background_level_2
                  }]">
                  <span class="label_2_name" 
                  @click.stop="templet.is_jump({href:`${routerType}?${linkKey}=${child.id}&name=${child.name}`,target:pc_widgets_infor.linkType})"
                  :style="[fontStyle_level_2, lineHeight_level_2,{
                        '--fontSeColor_2': infor.font_level_2[infor.font_level_2.radio_val].selectColor
                      },seChildIndex == childIndex || isSelected(child) ? se_fontStyle_level_2 : '']">{{ child.name }}
                  </span>
                  <div class="img_content" @click.stop="child.children && child.children.length > 0 ? openSon($event,childIndex) : ''" :style="imgContentStyle">
                    <img class="level_icon level_2_icon" :class="seChildIndex == childIndex || isOpened(child) ? 'open' : ''" :style="{
                      width: infor.icon[infor.icon.radio_val].icon_width + 'px',
                      height: infor.icon[infor.icon.radio_val].icon_width + 'px',
                      opacity: child.children && child.children.length > 0 && infor.icon.radio_val == 'custom' ? 1 : 0
                    }" :src="infor.icon[infor.icon.radio_val].icon_url">
                  </div>
                </div>
                <ul @mouseenter="(e)=>{mouse_dialog_show(e,childIndex,true,'level_3')}" @mouseleave="(e)=>{mouse_dialog_show(e,childIndex,false,'level_2')}" class="level_3" :class="{selected : isSelected(child), opened: isOpened(child)}">
                  <li class="level_3_content" v-for="(son,index) in child.children" :key="index">
                    <div class="level_3_content_new son_content" @mouseenter="(e)=>{hoverMoveChange(e, true,'level_3')}" @mouseleave="(e)=>{hoverMoveChange(e, false,'level_3')}" :style="[{
                          background: isSelected(son) ? se_background_level_3 : background_level_3,
                          borderBottom: `${infor.splitLine_level_3[infor.splitLine_level_3.radio_val].borderWidth}px ${infor.splitLine_level_3[infor.splitLine_level_3.radio_val].borderStyle} ${infor.splitLine_level_3[infor.splitLine_level_3.radio_val].borderColor}`,
                          '--sebackground_3': se_background_level_3
                        }]">
                      <span class="label_3_name" 
                      @click.stop="templet.is_jump({href:`${routerType}?${linkKey}=${son.id}&name=${son.name}`,target:pc_widgets_infor.linkType})"
                      :style="[label3PL,fontStyle_level_3, lineHeight_level_3,{
                              '--fontSeColor_3': infor.font_level_3[infor.font_level_3.radio_val].selectColor
                            },isSelected(son) ? se_fontStyle_level_3 : '']">{{ son.name }}
                      </span>
                    </div>
                  </li>
                </ul>
              </li>
            </ul>
          </li>
        </ul>
      </div>
      <div class="type_3 appoint_expand" v-if="listArr.moduleStyle === 3 && listArr.classificationSelect === 'appoint' && listArr.appoint_child_trigger !== 'no_expand'">
        <ul class="level_1">
          <li v-for="(parent,parentIndex) in filterList" :key="parentIndex" class="level_1_content" :class="infor.icon.radio_val == 'custom' ? `level_1_content_${infor.icon.custom.icon_position}` : 'level_1_content_'">
            <div class="level_1_content_new parent_content" @mouseenter="(e)=>{hoverMoveChange(e, true,'level_1')}" @mouseleave="(e)=>{hoverMoveChange(e, false,'level_1')}" :class="infor.icon.radio_val == 'custom' ? `item_content_${infor.icon.custom.icon_position}` : 'item_content'" :style="[{
              borderBottom: `${infor.splitLine_level_1[infor.splitLine_level_1.radio_val].borderWidth}px ${infor.splitLine_level_1[infor.splitLine_level_1.radio_val].borderStyle} ${infor.splitLine_level_1[infor.splitLine_level_1.radio_val].borderColor}`,
              background: seParentIndex == parentIndex || isSelected(parent) ? se_background_level_1 : background_level_1,
              '--sebackground_1': se_background_level_1
            }]">
              <span class="label_1_name"
              @click.stop="templet.is_jump({href:`${routerType}?${linkKey}=${parent.id}&name=${parent.name}`,target:pc_widgets_infor.linkType})"
              :style="[fontStyle_level_1, lineHeight_level_1,{
                '--fontSeColor_1': infor.font_level_1[infor.font_level_1.radio_val].selectColor
              },seParentIndex == parentIndex || isSelected(parent) ? se_fontStyle_level_1 : '']">
                {{ parent.name }}
              </span>
              <div class="img_content" @click.stop="toggleAppointExpand(parent.id, $event)" :style="imgContentStyle">
                <img :class="appointExpandMap[parent.id] ? 'open' : ''" :style="{
                  width: infor.icon[infor.icon.radio_val].icon_width + 'px',
                  height: infor.icon[infor.icon.radio_val].icon_width + 'px',
                  opacity: infor.icon.radio_val == 'custom' ? 1 : 0
                }" class="level_icon level_1_icon" :src="infor.icon[infor.icon.radio_val].icon_url">
              </div>
            </div>
            <ul class="level_2" :style="{ display: appointExpandMap[parent.id] ? 'block' : 'none' }">
              <li class="level_2_content" v-for="(item,idx) in (appointProducts[parent.id] || [])" :key="idx">
                <div class="level_2_content_new child_content" @mouseenter="(e)=>{hoverMoveChange(e, true,'level_2')}" @mouseleave="(e)=>{hoverMoveChange(e, false,'level_2')}" :style="[{
                    borderBottom: borderStyle_detail_nav.borderBottom,
                    paddingLeft: '20px',
                    background: background_detail_nav,
                    '--sebackground_2': se_background_detail_nav
                  }]">
                  <span class="label_2_name appoint_product_name"
                  @click.stop="goToDetail(item)"
                  :style="[fontStyle_detail_nav, lineHeight_detail_nav, {
                        '--fontSeColor_2': se_fontStyle_detail_nav.color
                      }]">{{ item.name }}
                  </span>
                </div>
              </li>
            </ul>
          </li>
        </ul>
      </div>
      <div class="type_2" v-if="listArr.moduleStyle === 2">
        <div class="left_content">
          <ul class="level_1">
            <li class="level_1_content" v-for="(parent,parentIndex) in filterList" :key="parentIndex" @mouseenter="(e)=>{mouse_dialog_show(e,parentIndex,true)}" @mouseleave="(e)=>{mouse_dialog_show(e,parentIndex,false)}">
              <div class="left_level1_content">
                <div class="parent_content level_1_content_new" @mouseenter="(e)=>{hoverMoveChange(e, true,'level_1')}" @mouseleave="(e)=>{hoverMoveChange(e, false,'level_1')}" :style="[{
                background: Number(searchID) === Number(parent.id) ? se_background_level_1 : background_level_1,
                borderBottom:  `${infor.splitLine_level_1[infor.splitLine_level_1.radio_val].borderWidth}px ${infor.splitLine_level_1[infor.splitLine_level_1.radio_val].borderStyle} ${infor.splitLine_level_1[infor.splitLine_level_1.radio_val].borderColor}`,
                '--sebackground_1': se_background_level_1
              }]" :class="infor.icon.radio_val == 'custom' ? `item_content_${infor.icon.custom.icon_position}` : 'item_content'">
                  <span class="parent_name label_1_name" 
                  @click.stop="templet.is_jump({href:`${routerType}?${linkKey}=${parent.id}&name=${parent.name}`,target:pc_widgets_infor.linkType})"
                  :style="[fontStyle_level_1,lineHeight_level_1,{
                    '--fontSeColor_1': infor.font_level_1[infor.font_level_1.radio_val].selectColor
                  },Number(searchID) === Number(parent.id) ? se_fontStyle_level_1 : '']">{{parent.name}}</span>
                  <div class="img_content" :style="imgContentStyle">
                    <img class="level_icon" :style="{
                      width: infor.icon[infor.icon.radio_val].icon_width + 'px',
                      height: infor.icon[infor.icon.radio_val].icon_width + 'px'
                    }" :src="infor.icon[infor.icon.radio_val].icon_url" v-if="parent.children && parent.children.length > 0 && infor.icon.radio_val == 'custom'">
                  </div>
                </div>
              </div>
              <div class="right_content" @mouseenter="(e)=>{mouse_dialog_show(e,parentIndex,true)}" @mouseleave="(e)=>{mouse_dialog_show(e,parentIndex,false)}" v-show="parentIndex == seParentIndex && parent.children && parent.children.length > 0">
                <div class="level_2" v-for="(child,childIndex) in parent.children" :key="childIndex">
                  <div class="level_2_content" :style="{
                  borderBottom: `${infor.splitLine_level_2[infor.splitLine_level_2.radio_val].borderWidth}px ${infor.splitLine_level_2[infor.splitLine_level_2.radio_val].borderStyle} ${infor.splitLine_level_2[infor.splitLine_level_2.radio_val].borderColor}`
                }">
                    <span class="child_content level_2_content_new" :style="{
                      background: Number(searchID) === Number(child.id) ? se_background_level_2 : background_level_2,
                      '--sebackground_2': se_background_level_2
                  }" @mouseenter="(e)=>{hoverMoveChange(e, true,'level_2')}" @mouseleave="(e)=>{hoverMoveChange(e, false,'level_2')}">
                      <span class="label_2_name" 
                       @click.stop="templet.is_jump({href:`${routerType}?${linkKey}=${child.id}&name=${child.name}`,target:pc_widgets_infor.linkType})"
                      :style="[fontStyle_level_2, lineHeight_level_2,{
                      '--fontSeColor_2': infor.font_level_2[infor.font_level_2.radio_val].selectColor,
                    },Number(searchID) === Number(child.id) ? se_fontStyle_level_2 : '']">{{child.name}}</span>
                    </span>
                    <p class="level_3">
                      <span class="level_3_content son_content level_3_content_new" :style="{
                      background: Number(searchID) === Number(son.id) ? se_background_level_3 : background_level_3,
                     '--sebackground_3': se_background_level_3,
                     marginRight: 10 + 'px'
                    }" v-for="(son,index) in child.children" :key="index" @mouseenter="(e)=>{hoverMoveChange(e, true,'level_3')}" @mouseleave="(e)=>{hoverMoveChange(e, false,'level_3')}">
                        <span class="label_3_name" style="color: #666;font-size: 12px;font-weight: normal;" 
                        @click.stop="templet.is_jump({href:`${routerType}?${linkKey}=${son.id}&name=${son.name}`,target:pc_widgets_infor.linkType})"
                        :style="[fontStyle_level_3, lineHeight_level_3,{
                        '--fontSeColor_3': infor.font_level_3[infor.font_level_3.radio_val].selectColor,
                      },Number(searchID) === Number(son.id) ? se_fontStyle_level_3 : '']">{{son.name}}</span>
                      </span>
                    </p>
                  </div>
                </div>
              </div>
            </li>
          </ul>
        </div>
      </div>
      <div v-if="listArr.moduleStyle === 5" class="content_detail_style5">
        <ul class="level_1">
          <li v-for="level_1_item in filterList" :key="level_1_item.id">
            <div class="level_1_content level_1_content_new">
              <div class="parent_content" @mouseenter="(e)=>{hoverMoveChange(e, true,'level_1')}" @mouseleave="(e)=>{hoverMoveChange(e, false,'level_1')}" :style="[{
                  borderBottom: `${infor.splitLine_level_1[infor.splitLine_level_1.radio_val].borderWidth}px ${infor.splitLine_level_1[infor.splitLine_level_1.radio_val].borderStyle} ${infor.splitLine_level_1[infor.splitLine_level_1.radio_val].borderColor}`,
                  background: Number(searchID) === Number(level_1_item.id) ? se_background_level_1 : background_level_1,
                  '--sebackground_1': se_background_level_1,
                  textAlign: listArr.textAlign
                }]">
                <span class="label_1_name" 
                @click.stop="templet.is_jump({href:`${routerType}?${linkKey}=${level_1_item.id}&name=${level_1_item.name}`,target:pc_widgets_infor.linkType})"
                :style="[fontStyle_level_1,lineHeight_level_1,{
                    '--fontSeColor_1': infor.font_level_1[infor.font_level_1.radio_val].selectColor
                  },Number(searchID) === Number(level_1_item.id) ? se_fontStyle_level_1 : '']">{{ level_1_item.name }}</span>
              </div>
            </div>
            <ul class="level_2 level_2_content" :class="{ vertical: level_1_item.children }" v-if="level_1_item.children">
              <li v-for="level_2_item in level_1_item.children" :key="level_2_item.id">
                <p class="child_content level_2_content_new" :style="{
                    background: Number(searchID) === Number(level_2_item.id) ? se_background_level_2 : background_level_2,
                    '--sebackground_2': se_background_level_2,
                    textAlign: listArr.textAlign
                  }" @mouseenter="(e)=>{hoverMoveChange(e, true,'level_2')}" @mouseleave="(e)=>{hoverMoveChange(e, false,'level_2')}">
                  <span class="label_2_name" :style="[fontStyle_level_2, lineHeight_level_2,{
                        '--fontSeColor_2': infor.font_level_2[infor.font_level_2.radio_val].selectColor,
                        borderBottom: `${infor.splitLine_level_2[infor.splitLine_level_2.radio_val].borderWidth}px ${infor.splitLine_level_2[infor.splitLine_level_2.radio_val].borderStyle} ${infor.splitLine_level_2[infor.splitLine_level_2.radio_val].borderColor}`,
                      },Number(searchID) === Number(level_2_item.id) ? se_fontStyle_level_2 : '']"
                      @click.stop="templet.is_jump({href:`${routerType}?${linkKey}=${level_2_item.id}&name=${level_2_item.name}`,target:pc_widgets_infor.linkType})"
                      >{{ level_2_item.name }}</span>
                </p>
                <ul class="level_3 level_3_content" :class="{ vertical: level_2_item.children }" v-if="level_2_item.children">
                  <li v-for="level_3_item in level_2_item.children" :key="level_3_item.id" @mouseenter="(e)=>{hoverMoveChange(e, true,'level_3')}" @mouseleave="(e)=>{hoverMoveChange(e, false,'level_3')}" :style="[{
                        background: Number(searchID) === Number(level_3_item.id) ? se_background_level_3 : background_level_3,
                        borderBottom: `${infor.splitLine_level_3[infor.splitLine_level_3.radio_val].borderWidth}px ${infor.splitLine_level_3[infor.splitLine_level_3.radio_val].borderStyle} ${infor.splitLine_level_3[infor.splitLine_level_3.radio_val].borderColor}`,
                        '--sebackground_3': se_background_level_3,
                        textAlign: listArr.textAlign
                      }]" class="son_content level_3_content_new">
                    <p @mouseenter="(e)=>{hoverMoveChange(e, true,'level_3')}" @mouseleave="(e)=>{hoverMoveChange(e, false,'level_3')}">
                      <span class="label_3_name" :style="[label3PL,fontStyle_level_3, lineHeight_level_3,{
                        '--fontSeColor_3': infor.font_level_3[infor.font_level_3.radio_val].selectColor,
                      },Number(searchID) === Number(level_3_item.id) ? se_fontStyle_level_3 : '']" 
                      @click.stop="templet.is_jump({href:`${routerType}?${linkKey}=${level_3_item.id}&name=${level_3_item.name}`,target:pc_widgets_infor.linkType})"
                      >{{ level_3_item.name }}</span>
                    </p>
                  </li>
                </ul>
              </li>
            </ul>
          </li>
        </ul>
      </div>
      <div class="product_type_appoint" v-if="listArr.moduleStyle === 4">
        <ul class="level_1">
          <li v-for="(item,parentIndex) in filterList" :key="parentIndex" :style="borderStyle_level_1">
            <div>
              <div class="parent_content level_1_content level_1_content_new" @mouseenter="(e)=>{hoverMoveChange(e, true,'level_1')}" @mouseleave="(e)=>{hoverMoveChange(e, false,'level_1')}" :style="[{
              background: Number(searchID) === Number(item.id) ? se_background_level_1 : background_level_1,
                '--sebackground_1': se_background_level_1
              }]" :class="infor.icon.radio_val == 'custom' ? `item_content_${infor.icon.custom.icon_position}` : 'item_content'">
                <span class="label_1_name label_name" v-if="listArr.classificationSelect === 'navbar'" @click="navbarLink(item)" :style="[fontStyle_level_1, lineHeight_level_1,{
                    '--fontSeColor_1': infor.font_level_1[infor.font_level_1.radio_val].selectColor,
                    textAlign: pc_widgets_infor.icon.radio_val == 'default' ? listArr.textAlign : 'left'
                  },Number(searchID) === Number(item.id) ? se_fontStyle_level_1 : '']">
                  {{ item.name }}
                </span>
                <span v-else 
                @click.stop="templet.is_jump({href:`${routerType}?${linkKey}=${item.id}&name=${item.name}`,target:pc_widgets_infor.linkType})"
                :style="[fontStyle_level_1, lineHeight_level_1,{
                    '--fontSeColor_1': infor.font_level_1[infor.font_level_1.radio_val].selectColor,
                    textAlign: pc_widgets_infor.icon.radio_val == 'default' ? listArr.textAlign : 'left'
                  },Number(searchID) === Number(item.id) ? se_fontStyle_level_1 : '']" class="label_1_name label_name">{{ item.name }}</span>
                <div class="img_content" :style="imgContentStyle">
                  <img class="level_icon level_1_icon" :style="{
                  width: infor.icon[infor.icon.radio_val].icon_width + 'px',
                  height: infor.icon[infor.icon.radio_val].icon_width + 'px'
                }" :src="infor.icon[infor.icon.radio_val].icon_url" v-if="infor.icon.radio_val == 'custom'">
                </div>
              </div>
            </div>
          </li>
        </ul>
      </div>
    </div>
    <template v-if="$store.state.app.view_pattern === 'mb'">
      <my_mb_empty_tips v-if="filterList.length <= 0" :tip="$t('widgets_basic_article_info_edit_348')"></my_mb_empty_tips>
      <div class="view_pattern_mb" v-else>
        <div class="content_detail">
          <div class="product_type_all">
            <ul class="level_1">
              <li v-for="(level_1_item,level_1_key) in filterList" :key="level_1_key">
                <div :class="infor.icon.radio_val == 'custom' ? `item_content_${infor.icon.custom.icon_position}` : 'item_content'" :style="[borderStyle_level_1,{
                  background: seParentIndex == level_1_key || Number(searchID) === Number(level_1_item.id) ?  se_background_level_1 : background_level_1
                }]">
                  <span class="label_1_name" v-if="listArr.classificationSelect == 'navbar'" @click="navbarLink(level_1_item)" :style="[fontStyle_level_1, lineHeight_level_1,{
                  },seParentIndex == level_1_key || Number(searchID) === Number(level_1_item.id) ? se_fontStyle_level_1: '']">{{ level_1_item.name }}</span>
                  <span v-else class="label_1_name" 
                  @click.stop="templet.is_jump({href:`${routerType}?${linkKey}=${level_1_item.id}&name=${level_1_item.name}`,target:pc_widgets_infor.linkType})"
                  :style="[fontStyle_level_1, lineHeight_level_1,{
                  },seParentIndex == level_1_key || Number(searchID) === Number(level_1_item.id) ? se_fontStyle_level_1: '']">
                    {{ level_1_item.name }}
                  </span>
                  <div class="img_content" @click.prevent="level_1_item.children && level_1_item.children.length > 0 ? show_level($event,'level_1',level_1_key) : ''">
                    <img class="level_icon level_1_icon" :class="{open: seParentIndex == level_1_key}" :style="{
                        width: infor.icon[infor.icon.radio_val].icon_width + 'px',
                        height: infor.icon[infor.icon.radio_val].icon_width + 'px',
                        opacity: (level_1_item.children || listArr.classificationSelect == 'appoint') && infor.icon.radio_val == 'custom' ? 1 : 0
                      }" :src="infor.icon[infor.icon.radio_val].icon_url">
                  </div>
                </div>
                <ul class="level_2" :class="{level_2_show: seParentIndex == level_1_key }">
                  <li v-for="(level_2_item,level_2_key) in level_1_item.children" :key="level_2_key">
                    <div :class="infor.icon.radio_val == 'custom' ? `item_content_${infor.icon.custom.icon_position}` : 'item_content'" :style="[borderStyle_level_2,{
                    background: seChildIndex == level_2_key || Number(searchID) === Number(level_2_item.id) ?  se_background_level_2 : background_level_2
                  }]">
                      <span class="label_2_name" 
                      @click.stop="templet.is_jump({href:`${routerType}?${linkKey}=${level_2_item.id}&name=${level_2_item.name}`,target:pc_widgets_infor.linkType})"
                      :style="[fontStyle_level_2, lineHeight_level_2,{
                  },seChildIndex == level_2_key || Number(searchID) === Number(level_2_item.id) ? se_fontStyle_level_2 : '']">
                        {{ level_2_item.name }}
                      </span>
                      <div class="img_content" @click.prevent="level_2_item.children && level_2_item.children.length > 0 ? show_level($event,'level_2',level_2_key) : ''">
                        <img class="level_icon level_2_icon" :class="{open: seChildIndex == level_2_key}" :style="{
                        width: infor.icon[infor.icon.radio_val].icon_width + 'px',
                        height: infor.icon[infor.icon.radio_val].icon_width + 'px',
                        opacity: (level_2_item.children || listArr.classificationSelect == 'appoint') && infor.icon.radio_val == 'custom' ? 1 : 0
                      }" :src="infor.icon[infor.icon.radio_val].icon_url">
                      </div>
                    </div>
                    <ul class="level_3">
                      <li v-for="level_3_item in level_2_item.children" :key="level_3_item.id" :style="[borderStyle_level_3,{
                        background: Number(searchID) === Number(level_3_item.id) ? se_background_level_3 : background_level_3
                      }]">
                        <div :class="infor.icon.radio_val == 'custom' ? `item_content_${infor.icon.custom.icon_position}` : 'item_content'">
                          <span class="label_3_name" 
                          @click.stop="templet.is_jump({href:`${routerType}?${linkKey}=${level_3_item.id}&name=${level_3_item.name}`,target:pc_widgets_infor.linkType})"
                          style="width:100%;" :style="[label3PL,fontStyle_level_3, lineHeight_level_3,Number(searchID) === Number(level_3_item.id) ? se_fontStyle_level_3 : '']">
                            {{ level_3_item.name }}
                          </span>
                        </div>
                      </li>
                    </ul>
                  </li>
                </ul>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </template>
    <basic_management v-if="popShow && listArr.classificationType === 'productList'" :showTag.sync="popShow" :typeTag="0" @changeType="getTypeList"></basic_management>
    <basic_management v-if="popShow && listArr.classificationType !== 'productList'" :showTag.sync="popShow" :typeTag="articleType" @changeType="getTypeList"></basic_management>
  </div>
</template>
<script>
import i18n from '../../language/index'

import { proTypeList, gettypeList, widgetNavList, getGoodsList, getArticleListBy1 } from '@/api/app.js'
import { treeJsonToArray } from '@/utils/utils.js'
import { basic_classification_new_style } from "@/base/widgets_data_compatible";
export default {
  name: "basic_classification_edit",
  data() {
    return {
      articleType: 1,
      popShow: false,
      isHover: false,
      seParentIndex: -1,
      seChildIndex: -1,
      typeList: [],
      searchID: '',
      filterBy: [],
      filterByOptions: [],
      timer: null,
      isShow: false,
      level_2_index: -1,
      navbarList: [],
      appointProducts: {},
      appointExpandMap: {}
    };
  },
  props: {
    module: {
      type: Object,
      default: null
    },
    column: {
      type: Object,
      default: null
    },
    row: {
      type: Object,
      default: null
    },
    module_index: {
      type: Number,
      default: 0
    }
  },
  methods: {
    navbarLink(item) {
      this.templet.is_jump(()=> {
        this.templet.toPage(item);
      })
    },
    getNavList() {
      widgetNavList().then((res) => {
        if (res.code == 200) {
          this.navbarList = res.data
        } else {
          this.$message.error(res.message)
        }
      }).catch(error => {
        this.$message.error(error.message)
      })
    },
    openLevel1(e, item) {
      $(e.target).toggleClass('open')
      if (item.children && item.children.length > 0) {
        let domList = $(e.target).parents('li').children('ul')
        if (domList.length > 0) {
          for (let i = 0; i < domList.length; i++) {
            if ($(domList[i]).css('display') == 'block') {
              $(domList[i]).slideUp(300)
            } else {
              $(domList[i]).slideDown(300)
            }
            if ($(domList[i]).children('li').children('ul').length > 0) {
              const $childDoms = $(domList[i]).children('li')
              for (let j = 0; j < $childDoms.length; j++) {
                $($childDoms[j]).children('div').children('div').children('img').removeClass('open')
                $($childDoms[j]).children('ul').css({ display: 'none' })
              }
            }
          }
        }
      }
    },
    openLevel2(e, item) {
      if (this.listArr.moduleStyle === 0) {
        $(e.target).toggleClass('open')
        if (item.children && item.children.length > 0) {
          let dom = $(e.target).parents('li').children('ul').eq(0)
          if ($(dom).css('display') == 'block') {
            $(dom).slideUp(300)
          } else {
            $(dom).slideDown(300)
          }
        }
      }
    },
    clear_time(childId) {
      if (this.timer) {
        clearTimeout(this.timer);
      }
      this.timer = null
      if (this.level_2_index !== childId && childId !== -1) {
        this.level_2_index = childId
      } else {
        this.level_2_index = -1
      }
    },
    hover_Level2(e, childId, isShow) {
      let that = this
      if (that.listArr.moduleStyle === 1) {
        $(e.target).children('li').children('div').children('div').children('img').toggleClass('open')
        if (!isShow) {
          if (that.timer == null) {
            that.timer = setTimeout(() => {
              that.clear_time(childId)
            }, 300);
          }
        } else {
          that.clear_time(childId)
        }
      }
    },
    module_isHover(val) {
      this.isHover = val
    },
    openSon(e, childIndex) {
      if (this.seChildIndex !== childIndex && childIndex !== -1) {
        this.seChildIndex = childIndex
      } else {
        this.seChildIndex = -1
      }
      const dom = $(e.target).parents('li').children('ul').eq(0)
      const isStyle1 = this.$store.state.app.view_pattern === 'pc' && this.module.data.listArr.moduleStyle == 1 ? true : false
      if (isStyle1) {
        $(dom).css({ display: this.seChildIndex == -1 ? 'none' : 'block' })
      } else {
        if (this.seChildIndex == -1) {
          $(dom).slideUp(300)
        } else {
          $(dom).slideDown(300)
        }
      }
    },
    show_level(e, type, index) {
      if (type == 'level_1') {
        this.openOrShowChild(e, index)
      } else if (type == 'level_2') {
        this.openSon(e, index)
      }
    },
    add_content() {
      this.popShow = true
    },
    changeStyle(tabName) {
      this.templet.changeStyle(this.module, tabName)
    },
    openOrShowChild(e, parentIndex) {
      let selectId = -1
      if (parentIndex !== this.seParentIndex && parentIndex !== -1) {
        selectId = parentIndex
      }
      let dom = $(e.target).parents('li').children('ul').eq(0)
      if (selectId == -1) {
        $(dom).slideUp(300)
      } else {
        $(dom).slideDown(300)
      }
      this.seParentIndex = selectId
      this.seChildIndex = -1
      let $domList = $(e.target).parents('li').siblings()
      for (let i = 0; i < $domList.length; i++) {
        $($domList[i]).children('ul').css({ display: 'none' })
        if ($($domList[i]).children('ul').children('li').length > 0) {
          const $childDoms = $($domList[i]).children('ul').children('li')
          for (let j = 0; j < $childDoms.length; j++) {
            $($childDoms[j]).children('ul').css({ display: 'none' })
          }
        }
      }
    },
    reset_time(levelType, index, e) {
      let left = $(e.target).offset().left
      let $dom = null
      if (this.listArr.moduleStyle == 1) {
        $dom = $(e.target).parents('li').children('.level_3')
        left = $(`#u${this.module.widgets_id} .type_1`).offset().left
      } else {
        $dom = $(e.target).find('.right_content')
      }
      if (this.timer) {
        clearTimeout(this.timer);
      }
      this.timer = null
      this.show_level(e, levelType, index)
      let top = $(e.target).position().top + 'px'
      if (left > 300) { //左边
        $dom.css({ 'right': '100%', 'left': 'auto', 'top': top })
      } else { //右边
        $dom.css({ 'left': '100%', 'right': 'auto', 'top': top })
      }
    },
    mouse_dialog_show(e, index, isShow, levelType = "level_1") {
      if (this.listArr.moduleStyle !== 1 && this.listArr.moduleStyle !== 2) {
        return
      }
      if (!isShow) {
        if (this.timer == null) {
          this.timer = setTimeout(() => {
            this.reset_time(levelType, index, e)
          }, 300);
        }
      } else {
        this.reset_time(levelType, index, e)
      }
    },
    dialog_hover_show(childIndex) {
      if (this.listArr.moduleStyle == 1) {
        if (this.seChildIndex !== childIndex) {
          this.seChildIndex = childIndex
        } else {
          this.seChildIndex = -1
        }
      }
    },
    getTypeList() {
      if (this.listArr.classificationType === 'productList') {
        proTypeList({ hide: 'false', nav_hide: 1 }).then((res) => {
          if (res.code === 200) {
            this.typeList = res.data.rows
            this.modify_filterByOptions()
          } else {
            this.$message.error(res.message)
          }
        }).catch(error => {
          this.$message.error(error)
        })
      } else {
        if (this.listArr.classificationType === 'newsList') {
          this.articleType = 1
        } else if (this.listArr.classificationType === 'helpList') {
          this.articleType = 2
        } else if (this.listArr.classificationType === 'caseList') {
          this.articleType = 3
        } else if (this.listArr.classificationType === 'downloadList') {
          this.articleType = 4
        } else if (this.listArr.classificationType === 'videoList') {
          this.articleType = 11
        }
        gettypeList({ type: this.articleType, hide: 'false', nav_hide: 1 }).then(res => {
          if (res.code === 200) {
            this.typeList = res.data.list
            this.modify_filterByOptions()
          } else {
            this.$message.error(res.message);
          }
        }).catch(error => {
          this.$message.error(error)
        })
      }
    },
    modify_filterByOptions() {
      let typeArr = treeJsonToArray(this.typeList)
      typeArr = typeArr.map((item) => {
        return {
          name: item.name,
          id: item.id,
          data: item
        }
      })
      this.filterByOptions = typeArr
      // 指定内容绑定
      this.filterBy = []
      for (let i = 0; i < this.listArr.filterByIds.length; i++) {
        for (let j = 0; j < this.filterByOptions.length; j++) {
          if (this.listArr.filterByIds[i] === this.filterByOptions[j].id) {
            this.filterBy.push(this.filterByOptions[j])
            break
          }
        }
      }
      this.$nextTick(() => {
        this.init_data()
      })
    },
    init_data() {
      this.seParentIndex = -1
      this.seChildIndex = -1
      this.level_2_index = -1
      if (this.$store.state.app.view_pattern === 'pc' && (this.module.data.listArr.moduleStyle == 0 || this.module.data.listArr.moduleStyle == 1)) {
        this.resetDisplayData()
        if (this.module.data.listArr.child_trigger == 'default_open'  && this.searchID === undefined) { // 默认展开
          this.seParentIndex = 0
          this.$nextTick(() => {
            $(`#u${this.module.widgets_id} .view_pattern_pc li`).eq(0).children('ul').css({ display: 'block' })
            if (this.module.data.listArr.moduleStyle == 0) {
              this.seChildIndex = 0
              $(`#u${this.module.widgets_id} .view_pattern_pc li`).eq(0).children('ul').children('li').eq(0).children('ul').css({ display: 'block' })
            }
          })

        }
      }
    },
    resetDisplayData() {
      let domList = $(`#u${this.module.widgets_id} .view_pattern_pc .level_1_content`)
      let isAllOpen = this.module.data.listArr.child_trigger == 'all_open' ? true : false
      if (domList.length > 0) {
        for (let i = 0; i < domList.length; i++) {
          $(domList[i]).children('ul').css({ display: isAllOpen || ($(domList[i]).children('ul').hasClass('opened')) ? 'block' : 'none' })
          if ($(domList[i]).children('ul').children('li').length > 0) {
            const $childDoms = $(domList[i]).children('ul').children('li')
            for (let j = 0; j < $childDoms.length; j++) {
              $($childDoms[j]).children('ul').css({ display: (isAllOpen && this.listArr.moduleStyle === 0) || $($childDoms[j]).children('ul').hasClass('opened') ? 'block' : 'none' })
            }
          }
        }
      }
    },
    initialization_data() {
      if (typeof this.pc_widgets_infor.level_1_is_move == "undefined") {
        this.$set(this.pc_widgets_infor, "level_1_is_move", basic_classification_new_style().level_1_is_move);
        this.$set(this.pc_widgets_infor, "level_2_is_move", basic_classification_new_style().level_2_is_move);
        this.$set(this.pc_widgets_infor, "level_3_is_move", basic_classification_new_style().level_3_is_move);
      }
      if (typeof this.listArr.navbarByIds == "undefined") {
        this.$set(this.listArr, "navbarByIds", '');
      }
      if (typeof this.listArr.navbarByThemeName == "undefined") {
        this.$set(this.listArr, "navbarByThemeName", '');
      }
      if (typeof this.listArr.textAlign == "undefined") {
        this.$set(this.listArr, "textAlign", 'left');
      }
      if (typeof this.listArr.appoint_child_trigger == "undefined") {
        this.$set(this.listArr, "appoint_child_trigger", 'no_expand');
      }
    },
    hoverMoveChange(e, isHover, levelType) {
      const result = {
        level_1: {
          is_move: this.pc_widgets_infor.level_1_is_move
        },
        level_2: {
          is_move: this.pc_widgets_infor.level_2_is_move
        },
        level_3: {
          is_move: this.pc_widgets_infor.level_3_is_move
        }
      }
      const isOpen = result[levelType].is_move
      if (isOpen && this.$store.state.app.view_pattern === 'pc') {
        let dom = $(e.target).find('a').eq(0)
        if (isHover) {
          dom.css('marginLeft', `6px`)
        } else {
          dom.css('marginLeft', 0)
        }
      }
    },
    isSelected(val){
      if(val != undefined && val['selected'] == 'true'){
        return true
      }else{
        return false
      }
    },
    isOpened(val){
      // console.log('isOpened123', val.name, val.selected);
      // 进入某个一级分类时展开下面所有的二级
      if(this.listArr.moduleStyle === 0){
        if(val.selected === 'true') return true
      }
      if(val != undefined && val['open'] == 'true'){
        return true
      }else{
        return false
      }
    },
    fetchAppointProducts() {
      if (this.listArr.classificationSelect !== 'appoint' || this.listArr.appoint_child_trigger === 'no_expand') {
        return
      }
      const ids = this.listArr.filterByIds
      if (!ids || ids.length === 0) return
      // all_expand模式初始化展开状态
      if (this.listArr.appoint_child_trigger === 'all_expand') {
        ids.forEach(id => {
          this.$set(this.appointExpandMap, id, true)
        })
      }
      ids.forEach(id => {
        if (this.listArr.classificationType === 'productList') {
          getGoodsList({ type_id: id, is_up: 'true', rows: 100, noDomain: 1, subclass: 0 }).then(res => {
            if (res.code === 200) {
              this.$set(this.appointProducts, id, (res.data.rows || []).slice(0, 100))
            }
          })
        } else {
          getArticleListBy1({ category_id: id, is_up: 'true', rows: 100, type: this.articleType }).then(res => {
            if (res.code === 200) {
              this.$set(this.appointProducts, id, (res.data.rows || []).slice(0, 100))
            }
          })
        }
      })
    },
    toggleAppointExpand(parentId, e) {
      if (this.listArr.appoint_child_trigger === 'no_expand') return
      // 检查数据是否已加载
      if (!this.appointProducts[parentId]) return
      const isOpen = !!this.appointExpandMap[parentId]
      this.$set(this.appointExpandMap, parentId, !isOpen)
      const dom = $(e.target).parents('.level_1_content').children('.level_2').eq(0)
      if (isOpen) {
        $(dom).slideUp(300)
      } else {
        $(dom).slideDown(300)
      }
    },
    goToDetail(item) {
      this.templet.is_jump({ href: `${this.detailRouterType}?id=${item.id}`, target: this.pc_widgets_infor.linkType })
    }
  },
  watch: {
    '$store.state.app.view_pattern'(val) {
      if (val == 'mb') {
        this.seParentIndex = -1
        this.seChildIndex = -1
      } else {
        this.init_data()
      }
    },
    'listArr.filterByIds': {
      handler(val) {
        if (val) {
          this.modify_filterByOptions()
          this.fetchAppointProducts()
        }
      },
      deep: true
    },
    'listArr.child_trigger'(val) {
      this.child_trigger = val
      this.init_data()
    },
    'listArr.classificationSelect'(val) {
      if (val !== 'all') {
        this.listArr.moduleStyle = 3
      } else {
        this.listArr.moduleStyle = 0
      }
    },
    'listArr.appoint_child_trigger'(val) {
      if (val !== 'no_expand') {
        this.fetchAppointProducts()
      } else {
        this.appointProducts = {}
        this.appointExpandMap = {}
      }
      this.$nextTick(() => {
        this.init_data()
      })
    },
    'listArr.typeList': {
      handler(val) {
        if (val) {
          this.typeList = val
          this.modify_filterByOptions()
        }
      },
      deep: true
    },
    'listArr.moduleStyle'(val) {
      this.init_data()
    },
    '$store.state.app.view_pattern'(val) {
      this.init_data()
    },
    'listArr.classificationType'(val) {
      if (val === 'newsList') {
        this.articleType = 1
      } else if (val === 'helpList') {
        this.articleType = 2
      } else if (val === 'caseList') {
        this.articleType = 3
      } else if (val === 'videoList') {
        this.articleType = 11
      } else if (val === 'downloadList') {
        this.articleType = 4
      }
    }
  },
  computed: {
    label3PL() {
      let infor = this.module.data[this.$store.state.app.view_pattern + '_widgets_infor']
      return {
        paddingLeft: infor.icon.radio_val == 'custom' && infor.icon.custom.icon_position == 'left' ? 80 + infor.icon[infor.icon.radio_val].icon_width + 'px' : '60px',
        width: '100%'
      }
    },
    linkKey() {
      return this.listArr.classificationType == 'productList' ? 'id' : 'typeId'
    },
    imgContentStyle() {
      let infor = this.module.data[this.$store.state.app.view_pattern + '_widgets_infor']
      return {
        display: infor.icon.radio_val == 'custom' ? 'block' : 'none'
      }
    },
    routerType() {
      let routerType = 'product_index'
      switch (this.module.data.listArr.classificationType) {
        case 'productList':
          routerType = 'product_index'
          break
        case 'newsList':
          routerType = 'article_index'
          break
        case 'caseList':
          routerType = 'case_index'
          break
        case 'helpList':
          routerType = 'help_index'
          break
        case 'videoList':
          routerType = 'video_index'
          break
        case 'downloadList':
          routerType = 'download_index'
          break
      }
      return `#/${routerType}`
    },
    infor() {
      return this.module.data[
        this.$store.state.app.view_pattern + '_widgets_infor'
      ];
    },
    pc_widgets_infor() {
      return this.module.data.pc_widgets_infor
    },
    filterList() {
      let list = []
      if (this.module.data.listArr.classificationSelect === 'all') {
        list = this.typeList
      }
      if (this.module.data.listArr.classificationSelect === 'appoint') {
        list = this.filterBy
      }
      if (this.module.data.listArr.classificationSelect === 'navbar') {
        let arr = this.navbarList.filter(item => item.id == this.listArr.navbarByIds)
        if (this.listArr.navbarByThemeName !== '') {
          arr = this.navbarList.filter(item => item.theme_name == this.listArr.navbarByThemeName)
        }
        if (arr.length > 0) {
          list = arr[0].children
          // 老数据不为空，建立theme_name关联
          if (this.listArr.navbarByIds !== '' && this.listArr.navbarByThemeName == '') {
            this.listArr.navbarByThemeName = arr[0].theme_name
          }
        }
      }
      // 添加选中状态
      for (var i = list.length - 1; i >= 0; i--) {
        if (list[i]['id'] == this.searchID && list[i]['name'] == this.$route.query.name) {
          list[i]['selected'] = 'true'
        }
        if (list[i]['children'] !== undefined && list[i]['children'].length > 0) {
          for (var j = list[i]['children'].length - 1; j >= 0; j--) {
            if (list[i]['children'][j]['id'] == this.searchID && list[i]['children'][j]['name'] == this.$route.query.name){
              list[i]['selected'] = 'true'
              list[i]['open'] = 'true'
              list[i]['children'][j]['selected'] = 'true'
            }
            if(list[i]['children'][j]['children'] !== undefined && list[i]['children'][j]['children'].length > 0){
              for (var k = list[i]['children'][j]['children'].length - 1; k >= 0; k--) {
                if (list[i]['children'][j]['children'][k]['id'] == this.searchID && list[i]['children'][j]['children'][k]['name'] == this.$route.query.name){
                  list[i]['selected'] = 'true'
                  list[i]['children'][j]['selected'] = 'true'

                  list[i]['open'] = 'true'
                  list[i]['children'][j]['open'] = 'true'

                  list[i]['children'][j]['children'][k]['selected'] = 'true'
                }
              }
            }
          }
        }
      }
      return list
    },
    listArr() {
      return this.module.data.listArr;
    },
    detailRouterType() {
      switch (this.module.data.listArr.classificationType) {
        case 'productList': return '#/product'
        case 'newsList': return '#/article'
        case 'caseList': return '#/case'
        case 'helpList': return '#/help'
        case 'videoList': return '#/video'
        case 'downloadList': return '#/download'
        default: return '#/product'
      }
    },
    se_fontStyle_level_1() {
      let widgets_infor = this.module.data[
        this.$store.state.app.view_pattern + '_widgets_infor'
      ]
      let fontStyle = {
        color: widgets_infor.font_level_1[widgets_infor.font_level_1.radio_val].selectColor
      }
      return fontStyle
    },
    fontStyle_level_1() {
      let widgets_infor = this.module.data[
        this.$store.state.app.view_pattern + '_widgets_infor'
      ]
      let font = widgets_infor.font_level_1[widgets_infor.font_level_1.radio_val]
      let fontStyle = {
        webkitBackgroundClip: font.pattern === 'pure_color' ? '' : 'text',
        color: font.pattern === 'pure_color' ? font.color : 'transparent',
        backgroundImage: font.pattern === 'pure_color' ? '' : `linear-gradient(${font.linear_gradient.deg}deg, ${font.linear_gradient.start_color} ${font.linear_gradient.start_pointer}%, ${font.linear_gradient.end_color} ${font.linear_gradient.end_pointer}%)`,
        fontFamily: font.fontFamily,
        fontSize: font.fontSize + 'px',
        fontWeight: font.fontWeight,
        fontStyle: font.fontStyle,
        textDecoration: font.textDecoration
      }
      return fontStyle
    },
    fontStyle_level_2() {
      let widgets_infor = this.module.data[
        this.$store.state.app.view_pattern + '_widgets_infor'
      ]
      let font = widgets_infor.font_level_2[widgets_infor.font_level_2.radio_val]
      let fontStyle = {
        webkitBackgroundClip: font.pattern === 'pure_color' ? '' : 'text',
        color: font.pattern === 'pure_color' ? font.color : 'transparent',
        backgroundImage: font.pattern === 'pure_color' ? '' : `linear-gradient(${font.linear_gradient.deg}deg, ${font.linear_gradient.start_color} ${font.linear_gradient.start_pointer}%, ${font.linear_gradient.end_color} ${font.linear_gradient.end_pointer}%)`,
        fontFamily: font.fontFamily,
        fontSize: font.fontSize + 'px',
        fontWeight: font.fontWeight,
        fontStyle: font.fontStyle,
        textDecoration: font.textDecoration
      }
      return fontStyle
    },
    se_fontStyle_level_2() {
      let widgets_infor = this.module.data[
        this.$store.state.app.view_pattern + '_widgets_infor'
      ]
      let fontStyle = {
        color: widgets_infor.font_level_2[widgets_infor.font_level_2.radio_val].selectColor
      }
      return fontStyle
    },
    fontStyle_level_3() {
      let widgets_infor = this.module.data[
        this.$store.state.app.view_pattern + '_widgets_infor'
      ]
      let font = widgets_infor.font_level_3[widgets_infor.font_level_3.radio_val]
      let fontStyle = {
        webkitBackgroundClip: font.pattern === 'pure_color' ? '' : 'text',
        color: font.pattern === 'pure_color' ? font.color : 'transparent',
        backgroundImage: font.pattern === 'pure_color' ? '' : `linear-gradient(${font.linear_gradient.deg}deg, ${font.linear_gradient.start_color} ${font.linear_gradient.start_pointer}%, ${font.linear_gradient.end_color} ${font.linear_gradient.end_pointer}%)`,
        fontFamily: font.fontFamily,
        fontSize: font.fontSize + 'px',
        fontWeight: font.fontWeight,
        fontStyle: font.fontStyle,
        textDecoration: font.textDecoration
      }
      return fontStyle
    },
    se_fontStyle_level_3() {
      let widgets_infor = this.module.data[
        this.$store.state.app.view_pattern + '_widgets_infor'
      ]
      let fontStyle = {
        color: widgets_infor.font_level_3[widgets_infor.font_level_3.radio_val].selectColor
      }
      return fontStyle
    },
    lineHeight_level_1() {
      let widgets_infor = this.module.data[
        this.$store.state.app.view_pattern + '_widgets_infor'
      ]
      let lineHeight = {
        lineHeight: widgets_infor.lineHeight_level_1[widgets_infor.lineHeight_level_1.radio_val].lineHeight + 'px'
      }
      return lineHeight
    },
    lineHeight_level_2() {
      let widgets_infor = this.module.data[
        this.$store.state.app.view_pattern + '_widgets_infor'
      ]
      let lineHeight = {
        lineHeight: widgets_infor.lineHeight_level_2[widgets_infor.lineHeight_level_2.radio_val].lineHeight + 'px'
      }
      return lineHeight
    },
    lineHeight_level_3() {
      let widgets_infor = this.module.data[
        this.$store.state.app.view_pattern + '_widgets_infor'
      ]
      let lineHeight = {
        lineHeight: widgets_infor.lineHeight_level_3[widgets_infor.lineHeight_level_3.radio_val].lineHeight + 'px'
      }
      return lineHeight
    },
    background_level_1() {
      let infor = this.module.data[
        this.$store.state.app.view_pattern + '_widgets_infor'
      ]
      const background =
        infor.background_level_1[infor.background_level_1.radio_val].pattern == 'linear_gradient' ?
        'linear-gradient(' +
        infor.background_level_1[infor.background_level_1.radio_val].linear_gradient.deg +
        'deg,' +
        infor.background_level_1[infor.background_level_1.radio_val].linear_gradient.start_color +
        infor.background_level_1[infor.background_level_1.radio_val].linear_gradient.start_pointer +
        '%,' +
        infor.background_level_1[infor.background_level_1.radio_val].linear_gradient.end_color +
        infor.background_level_1[infor.background_level_1.radio_val].linear_gradient.end_pointer +
        '%)' :
        infor.background_level_1[infor.background_level_1.radio_val].color;
      return background;
    },
    se_background_level_1() {
      let infor = this.module.data[
        this.$store.state.app.view_pattern + '_widgets_infor'
      ]
      const background =
        infor.background_level_1[infor.background_level_1.radio_val].sePattern == 'linear_gradient' ?
        'linear-gradient(' +
        infor.background_level_1[infor.background_level_1.radio_val].seLinear_gradient.deg +
        'deg,' +
        infor.background_level_1[infor.background_level_1.radio_val].seLinear_gradient.start_color +
        infor.background_level_1[infor.background_level_1.radio_val].seLinear_gradient.start_pointer +
        '%,' +
        infor.background_level_1[infor.background_level_1.radio_val].seLinear_gradient.end_color +
        infor.background_level_1[infor.background_level_1.radio_val].seLinear_gradient.end_pointer +
        '%)' :
        infor.background_level_1[infor.background_level_1.radio_val].seColor;
      return background;
    },
    background_level_2() {
      let infor = this.module.data[
        this.$store.state.app.view_pattern + '_widgets_infor'
      ]
      const background =
        infor.background_level_2[infor.background_level_2.radio_val].pattern == 'linear_gradient' ?
        'linear-gradient(' +
        infor.background_level_2[infor.background_level_2.radio_val].linear_gradient.deg +
        'deg,' +
        infor.background_level_2[infor.background_level_2.radio_val].linear_gradient.start_color +
        infor.background_level_2[infor.background_level_2.radio_val].linear_gradient.start_pointer +
        '%,' +
        infor.background_level_2[infor.background_level_2.radio_val].linear_gradient.end_color +
        infor.background_level_2[infor.background_level_2.radio_val].linear_gradient.end_pointer +
        '%)' :
        infor.background_level_2[infor.background_level_2.radio_val].color;
      return background
    },
    se_background_level_2() {
      let infor = this.module.data[
        this.$store.state.app.view_pattern + '_widgets_infor'
      ]
      const background =
        infor.background_level_2[infor.background_level_2.radio_val].sePattern == 'linear_gradient' ?
        'linear-gradient(' +
        infor.background_level_2[infor.background_level_2.radio_val].seLinear_gradient.deg +
        'deg,' +
        infor.background_level_2[infor.background_level_2.radio_val].seLinear_gradient.start_color +
        infor.background_level_2[infor.background_level_2.radio_val].seLinear_gradient.start_pointer +
        '%,' +
        infor.background_level_2[infor.background_level_2.radio_val].seLinear_gradient.end_color +
        infor.background_level_2[infor.background_level_2.radio_val].seLinear_gradient.end_pointer +
        '%)' :
        infor.background_level_2[infor.background_level_2.radio_val].seColor;
      return background;
    },
    background_level_3() {
      let infor = this.module.data[
        this.$store.state.app.view_pattern + '_widgets_infor'
      ]
      const background =
        infor.background_level_3[infor.background_level_3.radio_val].pattern == 'linear_gradient' ?
        'linear-gradient(' +
        infor.background_level_3[infor.background_level_3.radio_val].linear_gradient.deg +
        'deg,' +
        infor.background_level_3[infor.background_level_3.radio_val].linear_gradient.start_color +
        infor.background_level_3[infor.background_level_3.radio_val].linear_gradient.start_pointer +
        '%,' +
        infor.background_level_3[infor.background_level_3.radio_val].linear_gradient.end_color +
        infor.background_level_3[infor.background_level_3.radio_val].linear_gradient.end_pointer +
        '%)' :
        infor.background_level_3[infor.background_level_3.radio_val].color;
      return background
    },
    se_background_level_3() {
      let infor = this.module.data[
        this.$store.state.app.view_pattern + '_widgets_infor'
      ]
      const background =
        infor.background_level_3[infor.background_level_3.radio_val].sePattern == 'linear_gradient' ?
        'linear-gradient(' +
        infor.background_level_3[infor.background_level_3.radio_val].seLinear_gradient.deg +
        'deg,' +
        infor.background_level_3[infor.background_level_3.radio_val].seLinear_gradient.start_color +
        infor.background_level_3[infor.background_level_3.radio_val].seLinear_gradient.start_pointer +
        '%,' +
        infor.background_level_3[infor.background_level_3.radio_val].seLinear_gradient.end_color +
        infor.background_level_3[infor.background_level_3.radio_val].seLinear_gradient.end_pointer +
        '%)' :
        infor.background_level_3[infor.background_level_3.radio_val].seColor;
      return background;
    },
    borderStyle_level_1() {
      let widgets_infor = this.module.data[
        this.$store.state.app.view_pattern + '_widgets_infor'
      ]
      let splitLine = {
        borderBottom: `${widgets_infor.splitLine_level_1[widgets_infor.splitLine_level_1.radio_val].borderWidth}px ${widgets_infor.splitLine_level_1[widgets_infor.splitLine_level_1.radio_val].borderStyle} ${widgets_infor.splitLine_level_1[widgets_infor.splitLine_level_1.radio_val].borderColor}`
      }
      return splitLine
    },
    borderStyle_level_2() {
      let widgets_infor = this.module.data[
        this.$store.state.app.view_pattern + '_widgets_infor'
      ]
      let splitLine = {
        borderBottom: `${widgets_infor.splitLine_level_2[widgets_infor.splitLine_level_2.radio_val].borderWidth}px ${widgets_infor.splitLine_level_2[widgets_infor.splitLine_level_2.radio_val].borderStyle} ${widgets_infor.splitLine_level_2[widgets_infor.splitLine_level_2.radio_val].borderColor}`
      }
      return splitLine
    },
    borderStyle_level_3() {
      let widgets_infor = this.module.data[
        this.$store.state.app.view_pattern + '_widgets_infor'
      ]
      let splitLine = {
        borderBottom: `${widgets_infor.splitLine_level_3[widgets_infor.splitLine_level_3.radio_val].borderWidth}px ${widgets_infor.splitLine_level_3[widgets_infor.splitLine_level_3.radio_val].borderStyle} ${widgets_infor.splitLine_level_3[widgets_infor.splitLine_level_3.radio_val].borderColor}`
      }
      return splitLine
    },
    fontStyle_detail_nav() {
      let widgets_infor = this.module.data[
        this.$store.state.app.view_pattern + '_widgets_infor'
      ]
      let field = widgets_infor.font_detail_nav || widgets_infor.font_level_2
      if (!field || !field.radio_val) { return {} }
      let font = field[field.radio_val]
      let fontStyle = {
        webkitBackgroundClip: font.pattern === 'pure_color' ? '' : 'text',
        color: font.pattern === 'pure_color' ? font.color : 'transparent',
        backgroundImage: font.pattern === 'pure_color' ? '' : `linear-gradient(${font.linear_gradient.deg}deg, ${font.linear_gradient.start_color} ${font.linear_gradient.start_pointer}%, ${font.linear_gradient.end_color} ${font.linear_gradient.end_pointer}%)`,
        fontFamily: font.fontFamily,
        fontSize: font.fontSize + 'px',
        fontWeight: font.fontWeight,
        fontStyle: font.fontStyle,
        textDecoration: font.textDecoration
      }
      return fontStyle
    },
    se_fontStyle_detail_nav() {
      let widgets_infor = this.module.data[
        this.$store.state.app.view_pattern + '_widgets_infor'
      ]
      let field = widgets_infor.font_detail_nav || widgets_infor.font_level_2
      if (!field || !field.radio_val) { return {} }
      let fontStyle = {
        color: field[field.radio_val].selectColor
      }
      return fontStyle
    },
    background_detail_nav() {
      let infor = this.module.data[
        this.$store.state.app.view_pattern + '_widgets_infor'
      ]
      let field = infor.background_detail_nav || infor.background_level_2
      if (!field || !field.radio_val) { return 'rgba(255, 255, 255,1)' }
      const background =
        field[field.radio_val].pattern == 'linear_gradient' ?
        'linear-gradient(' +
        field[field.radio_val].linear_gradient.deg +
        'deg,' +
        field[field.radio_val].linear_gradient.start_color +
        field[field.radio_val].linear_gradient.start_pointer +
        '%,' +
        field[field.radio_val].linear_gradient.end_color +
        field[field.radio_val].linear_gradient.end_pointer +
        '%)' :
        field[field.radio_val].color || 'rgba(255, 255, 255,1)';
      return background
    },
    se_background_detail_nav() {
      let infor = this.module.data[
        this.$store.state.app.view_pattern + '_widgets_infor'
      ]
      let field = infor.background_detail_nav || infor.background_level_2
      if (!field || !field.radio_val) { return 'rgba(255, 255, 255,1)' }
      const background =
        field[field.radio_val].sePattern == 'linear_gradient' ?
        'linear-gradient(' +
        field[field.radio_val].seLinear_gradient.deg +
        'deg,' +
        field[field.radio_val].seLinear_gradient.start_color +
        field[field.radio_val].seLinear_gradient.start_pointer +
        '%,' +
        field[field.radio_val].seLinear_gradient.end_color +
        field[field.radio_val].seLinear_gradient.end_pointer +
        '%)' :
        field[field.radio_val].seColor || 'rgba(255, 255, 255,1)';
      return background;
    },
    lineHeight_detail_nav() {
      let widgets_infor = this.module.data[
        this.$store.state.app.view_pattern + '_widgets_infor'
      ]
      let field = widgets_infor.lineHeight_detail_nav || widgets_infor.lineHeight_level_2
      if (!field || !field.radio_val) { return { lineHeight: '38px' } }
      return {
        lineHeight: field[field.radio_val].lineHeight + 'px'
      }
    },
    borderStyle_detail_nav() {
      let widgets_infor = this.module.data[
        this.$store.state.app.view_pattern + '_widgets_infor'
      ]
      let field = widgets_infor.splitLine_detail_nav || widgets_infor.splitLine_level_2
      if (!field || !field.radio_val) { return { borderBottom: '0px solid rgba(236, 236, 236, 1)' } }
      let splitLine = {
        borderBottom: `${field[field.radio_val].borderWidth || 0}px ${field[field.radio_val].borderStyle || 'solid'} ${field[field.radio_val].borderColor || 'rgba(236, 236, 236, 1)'}`
      }
      return splitLine
    }
  },
  created() {
    this.initialization_data()
    this.getTypeList()
    this.getNavList()
    if (this.$route.name === 'product_index') {
      this.searchID = this.$route.query.id
    } else if (this.$route.name === 'article_index' || this.$route.name === 'help_index' || this.$route.name === 'case_index') {
      this.searchID = this.$route.query.typeId
    }
    // appoint展开模式初始化
    if (this.listArr.classificationSelect === 'appoint' && this.listArr.appoint_child_trigger !== 'no_expand') {
      this.fetchAppointProducts()
    }
  }
};

</script>
<style scoped lang="scss">
.open {
  transform: rotate(-90deg);
}

.view_pattern_pc {
  a {
    -webkit-transition: all 0.35s cubic-bezier(0.4, 0, 0.2, 1);
    -moz-transition: all 0.35s cubic-bezier(0.4, 0, 0.2, 1);
    -ms-transition: all 0.35s cubic-bezier(0.4, 0, 0.2, 1);
    -o-transition: all 0.35s cubic-bezier(0.4, 0, 0.2, 1);
    transition: all 0.35s cubic-bezier(0.4, 0, 0.2, 1);
    display: inline-block;
    flex: 1;
  }

  .level_icon {
    vertical-align: middle;
    width: 20px;
    height: 20px;
    display: inline-block;
  }

  .item_content_left {
    display: inline-flex;
    justify-content: flex-end;
    align-items: center;
    flex-direction: row-reverse;
    width: 100%;

    .label_2_name {
      padding-left: 20px;
    }

    .level_2_icon {
      margin-left: 20px;
    }
  }

  .item_content_right {
    display: inline-flex;
    align-items: center;
    width: 100%;

    .label_1_name {
      padding-left: 20px;
    }

    .label_2_name {
      padding-left: 40px;
    }
  }

  .item_content {
    display: flex;
    align-items: center;
    width: 100%;

    .label_1_name {
      padding-left: 20px;
    }

    .label_2_name {
      padding-left: 40px;
    }
  }

  a {
    -webkit-background-clip: text;
    font-size: 16px;
    color: #333;
    line-height: 32px;
  }

  .type_0 {
    .label_3_name {
      padding-right: 20px;
      word-wrap: break-word;
      display: inline-block;
    }
  }

  .type_1 {
    .level_2_content {
      position: relative;
    }

    .child_content {
      background-color: #F2F2F2;
    }

    .level_3 {
      position: absolute;
      left: 100%;
      z-index: 100;
      top: 0;
      width: 300px;
      overflow-x: hidden;
      overflow-y: auto;
      max-height: 500px;

      .son_content {
        padding-left: 20px;
        padding-right: 20px;
      }

      .label_3_name {
        padding-left: 0;
      }
    }
  }

  .type_2 {
    .left_content {
      position: relative;

      li {
        &:last-child {
          .left_level1_content {
            border-bottom: 1px solid #ececec;
          }
        }

        .left_level1_content {
          border-top: 1px solid #ececec;
          border-left: 1px solid #ececec;
          border-right: 1px solid #ececec;
          width: 100%;

          .parent_content {
            display: flex;
            align-items: center;
            line-height: 32px;
            font-size: 14px;
            font-weight: 400;
            color: #666;
          }
        }
      }
    }

    .right_content {
      position: absolute;
      left: 100%;
      // top: 0;
      min-width: 300px;
      border: 2px solid #ececec;
      background-color: #FFF;
      color: #333;
      font-size: 12px;
      transition: none 0s ease 0s;
      transform: translateZ(0);
      overflow-x: hidden;
      overflow-y: auto;
      height: 300px;
      max-width: 100%;
      padding: 10px 20px 10px 10px;
      z-index: 100;

      .level_2 {
        display: block !important;

        a {
          line-height: 34px;
          font-size: 14px;
          color: #333;
          font-weight: bold;
        }
      }

      .level_3 {
        display: block !important;
        padding-left: 10px;

        a {
          color: rgb(102, 102, 102);
          font-size: 12px;
          font-weight: normal;
          padding-right: 10px;
        }
      }
    }
  }

  .content_detail_style5 {
    .level_1 {
      display: flex;
      flex-wrap: wrap;
      margin-bottom: -1px;

      &>li {
        width: 25%;
        box-sizing: border-box;
        padding: 30px 12px;
        position: relative;
        border-bottom: 1px solid #ececec !important;

        .label_1_name {
          width: 100%;
          display: inline-block;
          display: inline-block;
          font-size: 16px;
          color: #333;
          line-height: 32px;
          padding-left: 10px;
        }

        &::after {
          content: '';
          display: block;
          position: absolute;
          top: 20px;
          right: 0;
          height: calc(100% - 40px);
          border-right: 1px dashed #ececec;
        }
      }
    }

    .level_2 {
      &>li {
        width: 100%;
        display: inline-block;

        .label_2_name {
          width: 100%;
          display: inline-block;
          line-height: 32px;
          padding-left: 20px;
          font-size: 14px;
          color: #666;
        }
      }
    }

    .level_3 {
      &>li {
        width: 100%;
        display: inline-block;

        .label_3_name {
          width: 100%;
          display: inline-block;
          line-height: 32px;
          padding-left: 30px;
          font-size: 14px;
          color: #666;
        }
      }
    }
  }

  .product_type_appoint {
    .level_1 {
      display: flex;
      flex-wrap: wrap;
      margin-bottom: -1px;

      &>li {
        width: 25%;
        box-sizing: border-box;
        padding: 30px 12px;
        position: relative;
        border-bottom: 1px solid #ececec;

        &::after {
          content: '';
          display: block;
          position: absolute;
          top: 20px;
          right: 0;
          height: calc(100% - 40px);
          border-right: 1px dashed #ececec;
        }
      }
    }
  }
}

.view_pattern_mb {
  .level_icon {
    vertical-align: middle;
    width: 20px;
    height: 20px;
    display: inline-block;
  }

  .item_content_left {
    display: inline-flex;
    justify-content: flex-end;
    align-items: center;
    flex-direction: row-reverse;
    width: 100%;

    .label_2_name {
      padding-left: 20px;
    }

    .level_2_icon {
      margin-left: 20px;
    }
  }

  .item_content_right {
    display: inline-flex;
    align-items: center;
    width: 100%;

    .label_1_name {
      padding-left: 20px;
    }

    .label_2_name {
      padding-left: 40px;
    }
  }

  .item_content {
    display: flex;
    align-items: center;
    width: 100%;

    .label_1_name {
      padding-left: 20px;
    }

    .label_2_name {
      padding-left: 40px;
    }
  }

  .data_empty {
    padding: 48px 0;

    .empty_tips_text {
      font-size: 14px;
      margin-top: 0;
    }
  }

  .content_detail {
    a {
      color: #333;
      position: relative;
      flex: 1;
    }

    .level_1 {
      &>li {
        &>div {
          border-bottom: 1px solid #ececec;

          a {
            font-size: 15px;
          }
        }
      }
    }

    .level_2 {
      &>li {
        &>div {
          border-bottom: 1px solid #ececec;

          a {
            font-size: 14px;
          }
        }
      }
    }

    .level_3 {
      &>li {
        &>div {
          border-bottom: 1px solid #ececec;

          a {
            font-size: 14px;
          }
        }
      }
    }
  }
}

.data_empty {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 90px 0;

  .empty_tips_img {
    display: block;
    width: 157px;
    height: 123px;
    margin: 0 auto 28px;
    background: url(~@/assets/image/default_icon.png) 0 0;
  }

  .empty_tips_text {
    margin-top: 28px;
    font-size: 16px;
    line-height: 24px;
    color: #333;
    text-align: center;
  }

  .btn_group {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    margin-top: 20px;

    /deep/ .el-button {
      margin: 10px 15px;
    }
  }
}

.level_1_content_new:hover .label_1_name {
  color: var(--fontSeColor_1) !important;
}

.level_2_content_new:hover .label_2_name {
  color: var(--fontSeColor_2) !important;
}

.level_3_content_new :hover .label_3_name {
  color: var(--fontSeColor_3) !important;
}

.label_3_name:hover {
  color: var(--fontSeColor_3) !important;
}

.parent_content:hover {
  background: var(--sebackground_1) !important;
}

.child_content:hover {
  background: var(--sebackground_2) !important;
}

.son_content:hover {
  background: var(--sebackground_3) !important;
}

.img_content {
  width: auto;
  margin: 10px;
  height: 100%;
  text-align: center;
  transition: all 4s ease;
}

.all_open .level_3 {
  display: block;
}

.all_open .view_pattern_mb .level_3 {
  display: block;
}

.all_open .type_1 .level_3 {
  display: block;
}

.appoint_product_name {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
  text-overflow: ellipsis;
  word-break: break-all;
}

</style>



// WEBPACK FOOTER //
// src/widgets/basic_classification/index.vue